import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/shared/Notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

import { CompanyInfoVungTrong } from 'src/app/shared/CompanyInfoVungTrong.model';
import { CompanyInfoVungTrongService } from 'src/app/shared/CompanyInfoVungTrong.service';

import { CompanyInfo } from 'src/app/shared/CompanyInfo.model';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';
//import { CoSoCompanyInfoVungTrongViewComponent } from '../co-so-CompanyInfoVungTrong-view/co-so-CompanyInfoVungTrong-view.component';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { CompanyInfoVungTrongDetailComponent } from '../company-info-vung-trong-detail/company-info-vung-trong-detail.component';
import { CompanyInfoDetailComponent } from '../company-info-detail/company-info-detail.component';
import { TinhTrangHoSoService } from 'src/app/shared/TinhTrangHoSo.service';

import { TinhTrangTDKTGSService } from 'src/app/shared/TinhTrangTDKTGS.service';
import { MatHangXuatKhauService } from 'src/app/shared/MatHangXuatKhau.service';
import { MatHangXuatKhau } from '../shared/MatHangXuatKhau.model';


@Component({
  selector: 'app-company-info-vung-trong',
  templateUrl: './company-info-vung-trong.component.html',
  styleUrls: ['./company-info-vung-trong.component.css']
})
export class CompanyInfoVungTrongComponent implements OnInit {

  @ViewChild('CompanyInfoVungTrongSort') CompanyInfoVungTrongSort: MatSort;
  @ViewChild('CompanyInfoVungTrongPaginator') CompanyInfoVungTrongPaginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public NotificationService: NotificationService,

    public CompanyInfoVungTrongService: CompanyInfoVungTrongService,

    public CompanyInfoService: CompanyInfoService,

    public ThanhVienService: ThanhVienService,
    
    public TinhTrangHoSoService: TinhTrangHoSoService,
    public TinhTrangTDKTGSService: TinhTrangTDKTGSService,
    public MatHangXuatKhauService: MatHangXuatKhauService,
  ) { }

  ngOnInit(): void {
    this.ThanhVienGetLogin();
    this.MatHangXuatKhauSearch();
    this.TinhTrangHoSoSearch();
    this.TinhTrangTDKTGSSearch();
  }

  MatHangXuatKhauSearch() {
    this.MatHangXuatKhauService.GetAllToListAsync().subscribe(
      res => {
          this.MatHangXuatKhauService.List = (res as any[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
          this.CompanyInfoVungTrongSearch();
      },
      err => {
      }
    );
  }

  ThanhVienGetLogin() {
    this.ThanhVienService.GetLogin();
  }
  isDateGreaterThanCurrentPlusThreeDays(dateToCheck: Date, dateWarning: number): boolean {
    if(dateToCheck==null) return false;
    const currentDate = new Date();
    const datePlusThreeDays = new Date(currentDate);
    datePlusThreeDays.setDate(currentDate.getDate() - dateWarning);
    return new Date(dateToCheck) < datePlusThreeDays;
  }
 
  // FindTinhTrangHoSoNameByID(idInput:number){

  //   if (idInput == null || idInput == undefined) return "";
    
  //   // // Kiểm tra xem danh sách đã được tải về chưa
  //   // if (!this.TinhTrangHoSoService.List || this.TinhTrangHoSoService.List.length === 0) {
  //   //   this.TinhTrangHoSoService.ComponentGetAllToListAsync();
  //   //   // Nếu danh sách chưa sẵn sàng, thực hiện gọi API để lấy dữ liệu
  //   //   setTimeout(() => {
  //   //     return this.FindTinhTrangHoSoNameByID(idInput);
  //   //   }, 1000);
  //   // }
    
  //   // Tìm kiếm trong danh sách đã có
  //   const item = this.TinhTrangHoSoService.List.find(l => l.ID == idInput);
  //   return item ? item.Name : "";
  // }
  FindTinhTrangHoSoNameByID(idInput:number){
    if(idInput == null || idInput == undefined) return "";
    return this.TinhTrangHoSoService.List.find(l=>l.ID == idInput)?.Name;
  }
  TinhTrangHoSoSearch() {
    this.TinhTrangHoSoService.ComponentGetAllToListAsync();
  }

  getNames(listMHXK: MatHangXuatKhau[]): string {
    return listMHXK.map(x => x.TTXKName).join(', ');
  }

  CompanyInfoVungTrongSearch() {
       
    this.CompanyInfoVungTrongService.IsShowLoading = true;        
    this.CompanyInfoVungTrongService.BaseParameter.Active = true;    
    this.CompanyInfoVungTrongService.GetByActiveToListAsync().subscribe(
      res => {
        this.CompanyInfoVungTrongService.List = (res as CompanyInfoVungTrong[]).sort((a, b) => (a.NgayGhiNhan < b.NgayGhiNhan ? 1 : -1)).filter(r=>r.Active && r.TypePlan == 1);
        this.CompanyInfoVungTrongService.List.forEach(element => {
          const listMHXK = this.MatHangXuatKhauService.List.filter(i=>i.Code == element.Code || i.ParentID == element.ID);
          element.MatHangXuatKhauList = this.getNames(listMHXK);
        });
        this.CompanyInfoVungTrongService.DataSource = new MatTableDataSource(this.CompanyInfoVungTrongService.List);
        this.CompanyInfoVungTrongService.DataSource.sort = this.CompanyInfoVungTrongSort;
        this.CompanyInfoVungTrongService.DataSource.paginator = this.CompanyInfoVungTrongPaginator;        
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      },
      err => {        
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      }
    );
  }
  CompanyInfoVungTrongDelete(element: CompanyInfoVungTrong) {
    this.CompanyInfoVungTrongService.IsShowLoading = true;
    element.Active = false;
    this.CompanyInfoVungTrongService.FormData = element;
    this.CompanyInfoVungTrongService.FormData.ParentID = this.CompanyInfoVungTrongService.FormData.ID;
    this.CompanyInfoVungTrongService.SaveAsync().subscribe(
      res => {
        this.NotificationService.warn(environment.SaveSuccess);
        this.CompanyInfoVungTrongSearch();
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.CompanyInfoVungTrongService.IsShowLoading = false;
      }
    );
  }

  CompanyInfoVungTrongAdd(ID: number) {
    this.CompanyInfoVungTrongService.BaseParameter.ID = ID;    
    this.CompanyInfoVungTrongService.GetByIDAsync().subscribe(
      res => {
        if(ID==0){
          this.CompanyInfoVungTrongService.FormData = res as CompanyInfoVungTrong;
        }else{
          this.CompanyInfoVungTrongService.FormData = {}
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: ID, IsStaff: true, CompanyInfoVungTrongDetail: res };
        const dialog = this.dialog.open(CompanyInfoVungTrongDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {
          this.CompanyInfoVungTrongSearch();
        });
      },
      err => {
      }
    );
  }  
  
  FindTinhTrangTDKTGSNameByID(idInput: number): string {
    if (idInput == null || idInput == undefined) return "";
    
    // // Kiểm tra xem danh sách đã được tải về chưa
    // if (!this.TinhTrangTDKTGSService.List || this.TinhTrangTDKTGSService.List.length === 0) {
    //   // Nếu danh sách chưa sẵn sàng, thực hiện gọi API để lấy dữ liệu
    //   this.TinhTrangTDKTGSService.ComponentGetAllToListAsync();
    //   setTimeout(() => {
    //     return this.FindTinhTrangTDKTGSNameByID(idInput);
    //   }, 1000);
    // }
    
    // Tìm kiếm trong danh sách đã có
    const item = this.TinhTrangTDKTGSService.List.find(l => l.ID == idInput);
    return item ? item.Name : "";
  }
  
  TinhTrangTDKTGSSearch() {
    this.TinhTrangTDKTGSService.ComponentGetAllToListAsync();
  }
  CompanyInfoAdd(ID: number) {
    this.CompanyInfoService.BaseParameter.ID = ID;    
    this.CompanyInfoService.GetByIDAsync().subscribe(
      res => {
        this.CompanyInfoService.FormData = res as CompanyInfo;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = environment.DialogConfigWidth;
        dialogConfig.data = { ID: ID };
        const dialog = this.dialog.open(CompanyInfoDetailComponent, dialogConfig);
        dialog.afterClosed().subscribe(() => {          
        });
      },
      err => {
      }
    );
  }  
}

